<profil-completion-gauge [percentageCompletion]="percentageCompletion" [tooltip]="tooltip"></profil-completion-gauge>
<profil-completion-actions [isVerified]="isVerified"></profil-completion-actions>
